import React from 'react';
import {Intent, Tag} from '@blueprintjs/core';
import numberFormat from 'number-format.js';

import {COMPARE_TO} from './constants';

interface CompareToProps {
  compareTo: string;
  value: number | null | undefined;
  format: string;
}

const getIntent = (value: number) => {
  if (value > 0) {
    return Intent.SUCCESS;
  } else if (value < 0) {
    return Intent.DANGER;
  }
  return Intent.NONE;
}

const highlightPlus = (value: number) => {
  if (value > 0) {
    return '+';
  }
  return '';
}

export const CompareTo = ({
  compareTo,
  value,
  format,
}: CompareToProps) => {
  if (compareTo === COMPARE_TO.NONE) {
    return null;
  }
  if (value === null || value === undefined) {
    return (
      <Tag
        round={true}
        large={true}
        minimal={true}
        intent={Intent.NONE}
      >
        Choose comparison
      </Tag>
    );
  }
  if (isNaN(value)) {
    return (
      <Tag
        round={true}
        large={true}
        minimal={true}
        intent={Intent.NONE}
      >
        No data
      </Tag>
    );
  }

  return (
    <Tag
      round={true}
      large={true}
      minimal={true}
      intent={getIntent(value)}
    >
      {highlightPlus(value)}{numberFormat(format, value)}
    </Tag>
  );
};

export default CompareTo;
